/* gb-blog-index.js — filtering, sorting and Load More for the Gun Beaver blog index.
   Client-side over the loaded set. Every state pushes to the URL so it is shareable
   and Back works. Category is NOT handled here: those are real /tagged/ pages. */
(function () {
  var root = document.getElementById('gb-index');
  if (!root) return;

  var rowsWrap = root.querySelector('[data-gb-rows]');
  var rail     = root.querySelector('#gb-rail');
  var backdrop = root.querySelector('[data-gb-backdrop]');
  var countEl  = root.querySelector('[data-gb-count]');
  var applyEl  = root.querySelector('[data-gb-applycount]');
  var fcountEl = root.querySelector('[data-gb-fcount]');
  var emptyEl  = root.querySelector('[data-gb-empty]');
  var moreWrap = root.querySelector('[data-gb-more]');
  var clearBtn = root.querySelector('[data-gb-clear]');

  var state = { types: [], price: null, sort: 'newest' };

  Array.prototype.forEach.call(root.querySelectorAll('[data-gb-jsonly]'), function (el) {
    el.hidden = false;
  });

  /* ---------- URL <-> state ---------- */
  function readUrl() {
    var p = new URLSearchParams(location.search);
    state.types = (p.get('type') || '').split(',').filter(Boolean);
    state.price = p.get('price') || null;
    state.sort  = p.get('sort') === 'discount' ? 'discount' : 'newest';
  }
  function writeUrl(replace) {
    var p = new URLSearchParams(location.search);
    state.types.length ? p.set('type', state.types.join(',')) : p.delete('type');
    state.price ? p.set('price', state.price) : p.delete('price');
    state.sort === 'discount' ? p.set('sort', 'discount') : p.delete('sort');
    var qs = p.toString();
    var url = location.pathname + (qs ? '?' + qs : '');
    history[replace ? 'replaceState' : 'pushState']({ gb: 1 }, '', url);
  }

  /* ---------- render ---------- */
  function rows() { return Array.prototype.slice.call(rowsWrap.querySelectorAll('[data-gb-row]')); }

  function matches(row) {
    if (state.types.length && state.types.indexOf(row.dataset.type) === -1) return false;
    if (state.price) {
      var price = parseFloat(row.dataset.price);
      if (isNaN(price)) return false;              // no priced pick -> out of a price filter
      var b = state.price.split('-');
      if (price < parseFloat(b[0]) || price > parseFloat(b[1])) return false;
    }
    return true;
  }

  function apply() {
    var all = rows(), shown = 0;
    all.forEach(function (r) {
      var ok = matches(r);
      r.hidden = !ok;
      if (ok) shown++;
    });

    if (state.sort === 'discount') {
      all.slice().sort(function (a, b) {
        var d = (parseInt(b.dataset.discount, 10) || 0) - (parseInt(a.dataset.discount, 10) || 0);
        return d !== 0 ? d : (parseInt(b.dataset.date, 10) || 0) - (parseInt(a.dataset.date, 10) || 0);
      }).forEach(function (r) { rowsWrap.appendChild(r); });
    } else {
      all.slice().sort(function (a, b) {
        return (parseInt(b.dataset.date, 10) || 0) - (parseInt(a.dataset.date, 10) || 0);
      }).forEach(function (r) { rowsWrap.appendChild(r); });
    }

    var filtering = state.types.length || state.price;
    var label = shown + ' article' + (shown === 1 ? '' : 's');
    if (countEl) countEl.textContent = filtering ? label + ' shown' : label;
    if (applyEl) applyEl.textContent = shown;
    if (emptyEl) emptyEl.hidden = shown !== 0;
    if (moreWrap) moreWrap.hidden = shown === 0;

    var n = state.types.length + (state.price ? 1 : 0);
    if (fcountEl) { fcountEl.textContent = n; fcountEl.hidden = n === 0; }
    if (clearBtn) clearBtn.hidden = n === 0;

    root.querySelectorAll('[data-gb-type]').forEach(function (b) {
      b.setAttribute('aria-pressed', state.types.indexOf(b.dataset.gbType) > -1);
    });
    root.querySelectorAll('[data-gb-price]').forEach(function (b) {
      b.setAttribute('aria-pressed', state.price === b.dataset.gbPrice);
    });
    root.querySelectorAll('[data-gb-sort]').forEach(function (b) {
      b.setAttribute('aria-pressed', state.sort === b.dataset.gbSort);
    });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gb-type],[data-gb-price],[data-gb-sort],[data-gb-open],[data-gb-close],[data-gb-clear],[data-gb-clear2],[data-gb-loadmore]');
    if (!t) return;

    if (t.hasAttribute('data-gb-type')) {
      var k = t.dataset.gbType, i = state.types.indexOf(k);
      i > -1 ? state.types.splice(i, 1) : state.types.push(k);
    } else if (t.hasAttribute('data-gb-price')) {
      state.price = state.price === t.dataset.gbPrice ? null : t.dataset.gbPrice;
    } else if (t.hasAttribute('data-gb-sort')) {
      state.sort = t.dataset.gbSort;
    } else if (t.hasAttribute('data-gb-open')) {
      openSheet(true); return;
    } else if (t.hasAttribute('data-gb-close')) {
      openSheet(false); return;
    } else if (t.hasAttribute('data-gb-clear') || t.hasAttribute('data-gb-clear2')) {
      state.types = []; state.price = null;
    } else if (t.hasAttribute('data-gb-loadmore')) {
      loadMore(t); return;
    }
    writeUrl(false);
    apply();
  });

  function openSheet(open) {
    if (!rail) return;
    open ? rail.setAttribute('data-open', '') : rail.removeAttribute('data-open');
    if (backdrop) open ? backdrop.setAttribute('data-open', '') : backdrop.removeAttribute('data-open');
    var btn = root.querySelector('[data-gb-open]');
    if (btn) btn.setAttribute('aria-expanded', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  if (backdrop) backdrop.addEventListener('click', function () { openSheet(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openSheet(false); });

  /* ---------- load more ---------- */
  function loadMore(btn) {
    var next = moreWrap && moreWrap.dataset.next;
    if (!next || btn.disabled) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'LOADING\u2026';

    fetch(next, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelectorAll('[data-gb-row]');
        Array.prototype.forEach.call(incoming, function (r) { rowsWrap.appendChild(r); });

        var nm = doc.querySelector('[data-gb-more]');
        if (nm && nm.dataset.next) {
          moreWrap.dataset.next = nm.dataset.next;
          btn.disabled = false;
          btn.textContent = label;
        } else {
          moreWrap.remove();
        }
        apply();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        window.location.href = next;   // fall back to a real page load
      });
  }

  window.addEventListener('popstate', function () { readUrl(); apply(); });

  readUrl();
  writeUrl(true);
  apply();
})();
